import { Slot } from '@radix-ui/react-slot'
import { PropsWithChildren, useRef, useState } from 'react'
import { toast } from 'sonner'

import { useAppDispatch, useAppSelector } from '@/redux/hooks'
import { SettingsActions } from '@/redux/reducers/settings'

type Props = {
  clicksToUnlock?: number
  enabled?: boolean
  resetAfterMs?: number
} & PropsWithChildren

export const UnlockDeveloperModeTrigger = ({
  children,
  clicksToUnlock = 5,
  enabled = true,
  resetAfterMs = 2000,
}: Props) => {
  const isDeveloper = useAppSelector(state => state.settings.isDeveloper)
  const dispatch = useAppDispatch()
  const [clickCount, setClickCount] = useState(0)
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)

  const handleClick = () => {
    setClickCount(prev => prev + 1)

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    timeoutRef.current = setTimeout(() => {
      setClickCount(0)
    }, resetAfterMs)

    if (clickCount + 1 >= clicksToUnlock) {
      dispatch(SettingsActions.setIsDeveloper(true))
      setClickCount(0)
      toast.success('Developer mode unlocked!')

      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }

  return <Slot {...(enabled && !isDeveloper && { onClick: handleClick })}>{children}</Slot>
}
